export default {"src":"/_next/static/image/public/images/ic_address_selected.7bdcfd41f11738071e4703c8663616b2.svg","height":30,"width":30};